import React from 'react';
import { FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';

/**
 * Premium Assessment Popup Component
 * Replaces SweetAlert2 with a unified design system.
 */
const AssessmentPopup = ({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  type = "warning", // warning, success, info
  showCancel = true,
  showInput = false,
  inputValue = "",
  onInputChange = () => {},
  inputPlaceholder = "Enter text...",
  children
}) => {
  if (!isOpen) return null;

  return (
    <div className="assessment-popup-overlay" onClick={onCancel}>
      <div className="assessment-popup-container" onClick={e => e.stopPropagation()}>
        <div className={`assessment-popup-icon ${type}`}>
          {type === 'warning' && <FiAlertCircle />}
          {type === 'success' && <FiCheckCircle />}
          {type === 'info' && <FiInfo />}
        </div>
        <h3 className="assessment-popup-title">{title}</h3>
        <p className="assessment-popup-message">{message}</p>

        {showInput && (
          <input 
            type="text"
            className="w-full bg-[#f8fafc] border border-slate-100 rounded-2xl px-5 py-3 text-[12px] font-black text-[#1e293b] focus:ring-4 focus:ring-red-50 outline-none transition-all placeholder:text-slate-300 shadow-inner mb-8"
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder={inputPlaceholder}
            autoFocus
          />
        )}

        {children}

        <div className="assessment-popup-actions">
          {showCancel && (
            <button 
              className="btn-assessment btn-assessment-secondary"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button 
            className={`btn-assessment ${type === 'warning' ? 'btn-assessment-danger' : 'btn-assessment-primary'}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssessmentPopup;
